import React from 'react';

function SubmitButton({ text }) {
  return (
    <button 
      type="submit" 
      className="w-full md:w-auto md:mx-auto md:min-w-[300px] bg-gradient-to-r from-rd-blue to-rd-cyan hover:from-rd-cyan hover:to-rd-blue text-rd-navy font-bold py-4 px-8 rounded-xl shadow-lg transform transition-all duration-300 hover:scale-105 hover:shadow-xl text-lg"
    >
      <span className="flex items-center justify-center">
        <span className="mr-2">🚀</span>
        {text}
      </span>
    </button>
  );
}

export default SubmitButton;
